import { unisonColors } from '@/theme';

export const onboardingColors = {
  gradientStart: unisonColors.brandPurpleLight,
  gradientEnd: unisonColors.brandPurple,
  brandPurple: unisonColors.brandPurple,
  outlinedText: unisonColors.brandPurpleDark,
  stepIndicatorActive: unisonColors.iconBrandBase,
  stepIndicatorInactive: unisonColors.borderNdInactive,
  illustrationBackground: unisonColors.brandGreenWeak,
  titleText: unisonColors.textNdPrimary,
  bodyText: unisonColors.textNdSecondary,
  background: unisonColors.white,
} as const;
